import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import history from '../../../../../history';
import __ from 'lodash';
import Loader from '../../../../Loader';
import { Row, Col, Alert, Modal } from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import accountManagement from '../../../../../apis/accountManagement';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';
import Select from 'react-select';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,IconButton,Typography,Collapse,Box, Button, ButtonGroup} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PaginationTable from '../../masterDropDown/PaginationTable';
import PaginationData from '../../../../../entity/PaginationData';
import ProfilSearch from '../../../../../entity/ProfilCbtSearch';
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import GetAppIcon from '@material-ui/icons/GetApp';


import respProfilAgcu from './respProfilAgcu'

class ListProfil extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching : false,
            namaProfil: '',
            listProfil : [],
            paginationData: PaginationData,
        }
    }

    componentDidUpdate(){
        // console.clear();
        console.log(this.props);
        this.fff();
        console.log('--------------------------------------------');
    }

    handleOnChange = async (e)=>{
        const name = e.target.name;
        const value = e.target.value;
        const tipe = this.props.kodeTipeCbt;

        this.setState({ 
            [name]:value,
            isSearch : true
        });

        // searchProfil
        if(name === 'namaProfil'){
            this.fetchProfil(value);
        }

        if(name === 'jumlahCari'){
            this.setState({ listProfil: [] });
            if(this.state.namaProfil != null){
                const response = await akmApi.post(URL_AKM.PROFIL_SEARCH_NAME, 
                    {
                        'namaProfil'    : this.state.namaProfil,
                        'kodeTipeCbt'   : tipe,
                        'idKurikulum'    : value
                    }
                ).catch(function(error){
                    this.setState({error})
                })

                this.setState({ listProfil: response.data.data });
            }
        }

    }

    handleChangePage = async(newPage) => {
        this.state.paginationData.page = newPage;
        this.fetchProfil(this.state.namaProfil);
    }

    handleChangeRowsPerPage = (size) => {
        this.state.paginationData.page = 0;
        this.state.paginationData.size = size;
        this.fetchProfil(this.state.namaProfil);
    }


    fetchProfil = async() => {
        /* this.setState({isFetching:true})
        const result = await akmApi.get(URL_AKM.AKM_LIST, {
            params: { page: this.state.paginationData.page, 
                    size: this.state.paginationData.size, 
                    tipeCbt: this.props.kodeSubTipeCbt }
        })
        if(result){
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listProfil: result.data.data.content,
                    paginationData: {...this.state.paginationData, 
                        page: result.data.data.number,
                        size: result.data.data.size,
                        totalPages: result.data.data.totalPages,
                        numberOfElements: result.data.data.numberOfElements,
                        totalElements: result.data.data.totalElements
                    }
                })
            } else {
                this.setState({
                    listSoal: [],
                    paginationData:PaginationData,
                    showAlert: true,
                    resMessage: result.data.errorSchema.errorMessage    
                })
            }
            this.setState({isFetching:false})
        }   */
        
        if(respProfilAgcu){
            if(respProfilAgcu.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listProfil: respProfilAgcu.data.content,
                    paginationData: {...this.state.paginationData, 
                        page: respProfilAgcu.data.number,
                        size: respProfilAgcu.data.size,
                        totalPages: respProfilAgcu.data.totalPages,
                        numberOfElements: respProfilAgcu.data.numberOfElements,
                        totalElements: respProfilAgcu.data.totalElements
                    }
                })
            } else {
                this.setState({
                    listSoal: [],
                    paginationData:PaginationData,
                    showAlert: true,
                    resMessage: respProfilAgcu.data.errorSchema.errorMessage    
                })
            }
            this.setState({isFetching:false})
        }
    } 

    setOpen = async(profil) => {
        this.setState(state => ({
            ...state,
            listProfil: this.state.listProfil.map(item =>
              item.idProfilCbt === profil.idProfilCbt ? { ...item, open: !profil.open } : { ...item, open: false }
            )
        }));
        if(!profil.open) {
            this.setState({ isFetching: true, listMapel: [] })           

            const response = await akmApi.get(URL_AKM.GET_SUBPROFIL_BY_IDPROFIL + profil.idProfilCbt).catch (function(error){ alert(error) })            

            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listMapel: response.data.data
                    })                        
                }   
                this.setState({isFetching: false});            
            }  

            if(profil.kodeTipeCbt != 'TOO')
                this.fetchNonAkademik(profil.idProfilCbt);      
        }  
    }
    
    changeMgtProfil = (e) => {
        this.props.changeMgtProfil(e)
    }

    changeMgtSoal = (status, profil, mapel) => {   
        this.props.changeMgtSoal(status, profil, mapel);
    }


    renderRow() { 
        return (
            <React.Fragment>
                {this.state.listProfil.map((profil,i) => 
                <>
                <TableRow key={i}>
                    <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => this.setOpen(profil)}>
                        {profil.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    </TableCell>
                    <TableCell align="left">{profil.namaProfil}</TableCell>
                    <TableCell align="left">{profil.kodeSubTipeCbt}</TableCell>
                    <TableCell align="left">{profil.namaKelas}</TableCell>
                    <TableCell align="right">
                        {<div className="button-group">
                            <button className="btn btn-outline-info btn-sm" onClick={() => this.changeMgtProfil(profil)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>&nbsp;
                            <button className="btn btn-outline-danger btn-sm" onClick={() => this.handleProfilDialog(profil)}><i className="fa fa-trash-o" aria-hidden="true"></i></button>								
                        </div>}
                    </TableCell>
                </TableRow> 
                
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={profil.open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                        <Typography variant="h6" gutterBottom component="div">
                            {/* <button className="btn btn-outline-primary btn-sm" onClick={() => this.handleSubProfil(profil,{})}>
                                <i className="fa fa-plus" aria-hidden="true"></i> tambah Details
                            </button>  */}
                        </Typography>
                        
                        <Table size="small" aria-label="mapel">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Mata Pelajaran</TableCell>
                                    <TableCell align="center">Soal</TableCell>
                                    <TableCell align="center">Durasi</TableCell>
                                    <TableCell align="center">KKM</TableCell>
                                    <TableCell align="center">Random</TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {!__.isEmpty(this.state.listMapel) &&
                                    this.state.listMapel.map((val, i)=>
                                        <TableRow>
                                            <TableCell>{val.namaMapel}</TableCell>
                                            <TableCell align="center">
                                                {val.jumlahSoal}
                                                <IconButton color="primary" size="small" title="preview soal..." component="span" onClick={() => this.handlePreviewSoal(profil, val)}>
                                                    <VisibilityRoundedIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton style={{color: '#dc3545'}} size="small" title="download soal..." component="span" onClick={() => this.handleDownloadSoal(profil, val)}>
                                                    <GetAppIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell align="center">{val.durasi}</TableCell>
                                            <TableCell align="center">{val.ketuntasanMinimum}</TableCell>
                                            <TableCell align="center">{val.random === 1 ? 
                                                <i className="fa fa-check text-success" aria-hidden="true"></i> :
                                                <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                            </TableCell>
                                            <TableCell align="right">
                                                <ButtonGroup variant="text" size="small" aria-label="text primary button group">
                                                    <Button style={{color: '#00a426'}} onClick={() => this.changeMgtSoal(true, profil, val)}>add soal</Button>
                                                    {/* <Button style={{color: '#ffc107'}} onClick={() => this.handleSubProfil(profil,val)}>edit</Button>
                                                    <Button style={{color: '#dc3545'}} onClick={() => this.handleSubProfilDialog(val)}>hapus</Button> */}
                                                </ButtonGroup>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                        </Box>
                    </Collapse>
                    </TableCell>
                </TableRow>
                </>
                )}
            </React.Fragment>
        );
    }

    render() { 
        const {open, paginationData, listSoal, isFetching} = this.state; 
        return ( 
            <>
                <LoaderModal isFetching={isFetching} />
                <br />
                <Row>
                    <Col sm={8}><h4>LIST PROFIL {this.props.kodeTipeCbt}</h4></Col>
                    <Col sm={4}>
                        <input type="text" className="form-control" placeholder="Cari Nama Profil" name="namaProfil" onChange={this.handleOnChange} autoComplete="off"/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {!__.isEmpty(this.state.listProfil) &&
                            <TableContainer component={Paper}>                    
                                <Table aria-label="collapsible table">
                                    <TableHead>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell align="left">Nama Profil</TableCell>
                                        <TableCell align="left">Kode Sub</TableCell>
                                        <TableCell align="left">Kelas Group</TableCell>
                                        <TableCell align="right">#Aksi</TableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.renderRow()}
                                    </TableBody>
                                </Table>
                                <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                            </TableContainer>
                        }
                        
                    </Col>
                </Row>
            </>
        );
    }
}
 
export default ListProfil;